<script setup lang="ts">
import { de } from '@nuxt/ui-pro/locale'
import { darkTheme, dateDeDE, deDE } from 'naive-ui'
import { appName } from '~/constants'
import { themeOverrides } from './theme.config'

useHead({
  title: appName,
})

const { isSplittingTimeEntry, isMergingTimeEntries } = storeToRefs(useTimeEntryActionsStore())

defineShortcuts({
  escape: () => {
    isSplittingTimeEntry.value = false
    isMergingTimeEntries.value = false
  },
})

const { colorMode } = useNaiveColorMode()

const theme = ref<typeof darkTheme | null>(null)

watch(colorMode, () => theme.value = colorMode.value === 'dark' ? darkTheme : null, { immediate: true })
</script>

<template>
  <naive-config
    :theme="theme"
    :theme-overrides="themeOverrides"
    :locale="deDE"
    :date-locale="dateDeDE"
  >
    <UApp :locale="de">
      <VitePwaManifest />

      <n-loading-bar-provider>
        <naive-loading-bar navigation />
      </n-loading-bar-provider>
      <NuxtLayout>
        <NuxtPage class="h-screen w-full overflow-y-auto" :class="{ 'cursor-split !hover:cursor-split': isSplittingTimeEntry, 'cursor-crosshair !hover:crosshair': isMergingTimeEntries, 'page-wrapper-cursor': isMergingTimeEntries || isSplittingTimeEntry }" />
      </NuxtLayout>
      <PWAUpdatePrompt />
    </UApp>
  </naive-config>
</template>

<style>
html,
body,
#__nuxt {
  height: 100vh;
  margin: 0;
  padding: 0;
}

:root {
  --bg-color: #fff;
  --text-color: #222;
}

html.dark {
  --bg-color: #222;
  --text-color: #fff;
}

html {
  background: var(--bg-color);
  color: var(--text-color);
}

.page-wrapper-cursor * {
  cursor: inherit !important;
}

.cursor-split {
  cursor:
    url('/cursor-split.png') 16 16,
    auto !important;
}

/* To disable the progress animation but keep the toast color */
[data-reka-collection-item] [role='progressbar'] [data-state='loading'] {
  @apply !transform-none;
}
</style>
